import { useFlags } from "features/api/flags"

export function useDeprecatedDeliveryExperienceFlag(): {
  isDeprecatedDeliveryExperienceEnabled: boolean
} {
  const { DEPRECATED_DELIVERY_EXPIERENCE } = useFlags()
  return {
    isDeprecatedDeliveryExperienceEnabled:
      DEPRECATED_DELIVERY_EXPIERENCE.boolVal,
  }
}
